import React, { useEffect, useRef, useState } from "react";
import styles from "./ProductDetailPage.module.css";
import ProductGallery from "../ProductGallery/ProductGallery";
import ProductInfo from "../ProductInfo/ProductInfo";
import ProductFeatures from "../ProductFeatures/ProductFeatures";
import ProductSpecifications from "../ProductSpecifications/ProductSpecifications";
import SimilarProducts from "../SimilarProducts/SimilarProducts";
import CustomerReviews from "../CustomerReviews/CustomerReviews";
import { Product, ProductDetail } from "../Types/product.types";
// import { useDispatch } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedInState } from "../../../redux/userState";
import { setLoading } from "../../../redux/loadingSlice";
import { useNavigate, useParams } from "react-router-dom";
import useProductAPI from "../../../api/useProductsAPI";
import { addToCart } from "../../../features/cart/cartSlice";
import { addToProduct, refreshProductList } from "../../../redux/productSlice";
import { Toast } from "primereact/toast";
import useCartAPI from "../../../api/useCartAPI";
import { setShowLoginDialog } from "../../../redux/dialogSlice";

const ProductDetailPage: React.FC = () => {
  const {
    getProductList,
    getProductReview,
    getProductBySlug,
    saveProductReviewAPi,
    getProductById,
  } = useProductAPI();
  const { cartSave } = useCartAPI();

  const basePath = process.env.REACT_APP_BASE_PATH;
  const [productData, setProductData] = useState(null) as any;
  const [productImages, setProductImages] = useState(null) as any;
  const { id } = useParams();
  // console.log(id, "id>>>>>>>>>>>>>>>>");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useRef<Toast>(null) as any;
  const [userId, setUserId] = useState(null) as any;
  const [isShowPrice, setIsShowPrice] = useState(false) as any;
  const isLoggedIn = useSelector(isLoggedInState);
  const [similarProducts, setSimilarProducts] = useState<Product[]>([]);
  const fetchProductBySlugFunc = async (id?: any) => {
    const response: any = await getProductById(id);
    // console.log("Product Details Response>>>>>>>>>>>>.:", response.data.data);
    if (response?.status === 200 || response?.status === 201) {
      setProductData(response?.data?.data);
      await fetchSimilarProducts(response.data.data);
      const productImages =
        response?.data?.data?.document_as_product?.length > 0
          ? response.data.data.document_as_product.map(
              (image: any) => image?.document?.file_path,
            )
          : ["https://mechmiles.com/not-available.png"];

      setProductImages(productImages);
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      // navigate(`${basePath}produ`);
    }
  };
  const fetchSimilarProducts = async (product: any) => {
    // console.log("product>>>>>>>>>>>>>>", product);
    const width = product?.width?.predefined_id;
    const aspect_ratio = product?.aspect_ratio?.predefined_id;
    const rim = product?.rim?.predefined_id;
    const payload = {
      page_size: 8,
      page_number: 1,
      user_id: userId,
      product_type_id: product?.product_type?.predefined_id,
      category_ids: [product?.category?.predefined_id],
    };

    if (!width || !aspect_ratio || !rim) {
      Object.assign(payload, { brand_ids: [product?.brand?.predefined_id] });
    } else {
      Object.assign(payload, {
        width_ids: [width],
        aspect_ratio_ids: [aspect_ratio],
        rim_ids: [rim],
      });
    }

    // console.log("payloadafter>>>>>>>>>>>>>>>", payload);

    try {
      const response: any = await getProductList(payload);

      if (response.status === 200 || response.status === 201) {
        // const products = (response.data.data || []).filter(
        //   (item: any) => item.product_id !== product.product_id,
        // );
        // console.log(response, "response>>>>>>>>>>>>>>");
        setSimilarProducts(response.data || []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // useEffect(() => {
  //   const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");
  //   setUserId(authTokens?.user?.id);
  //   if (authTokens?.user?.is_show_price === true) {
  //     setIsShowPrice(true);
  //   }
  //   if (id) {
  //     fetchProductBySlugFunc(id);
  //   }
  // }, [id]);
  // useEffect(() => {
  //   const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");

  //   setUserId(authTokens?.user?.id);

  //   setIsShowPrice(authTokens?.user?.is_show_price === true);

  //   if (id) {
  //     fetchProductBySlugFunc(id);
  //   }
  // }, [id]);
  useEffect(() => {
    if (!isLoggedIn) {
      setIsShowPrice(true); // guest → always show real price
    } else {
      const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");
      setUserId(authTokens?.user?.id);
      setIsShowPrice(authTokens?.user?.is_show_price === true);
    }

    if (id) {
      fetchProductBySlugFunc(id);
    }
  }, [id, isLoggedIn]);

  const handleAddToCart = async () => {
    if (!userId) {
      setTimeout(() => {
        dispatch(setShowLoginDialog(true));
      }, 1000);

      return toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `Please Login`,
      });
    }

    // navigate("/mechmiles-customer/cart", { state: { product } });

    const payload = {
      product_id: productData?.product_id,
      item_quantity: 1,
      is_wishList: false,
    };

    const response: any = await cartSave(payload);

    if (response.status === 201) {
      dispatch(addToCart(productData));
      dispatch(addToProduct(productData));
      dispatch(refreshProductList());
      setProductData((prevData: any) => ({
        ...prevData,
        is_goto: true,
      }));
      return toast?.current?.show({
        severity: "success",
        summary: "Success",
        detail: `${productData?.product_name} Added to cart`,
      });
    }
  };
  const handleBuyNow = async () => {
    if (!userId) {
      setTimeout(() => {
        dispatch(setShowLoginDialog(true));
      }, 1000);

      return toast.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Please Login",
      });
    }

    const payload = {
      product_id: productData?.product_id,
      item_quantity: 1,
      is_wishList: false,
    };

    const response: any = await cartSave(payload);

    if (response.status === 201 || response.status === 200) {
      dispatch(addToCart(productData));
      dispatch(addToProduct(productData));
      dispatch(refreshProductList());

      // Go directly to cart
      navigate(`${basePath}cart`, {
        state: {
          buyNow: true,
        },
      });
    }
  };
  return (
    <div className={styles.page}>
      {/* Top section: gallery + info */}
      <section className={styles.topSection}>
        <div className={styles.galleryCol}>
          <ProductGallery
            images={productImages}
            alt={productData?.name}
            brandLogo={productData?.brand?.thumbnail}
            brand={productData?.brand}
          />
        </div>
        <div className={styles.infoCol}>
          <ProductInfo
            brand={productData?.brand}
            isLoggedIn={isLoggedIn}
            isShowPrice={isShowPrice}
            product_feature={productData?.product_feature}
            product_id={productData?.product_id}
            compatible_vehicles={productData?.compatible_vehicles}
            name={productData?.product_name}
            product_price={productData?.product_price}
            product_offer_price={productData?.product_offer_price}
            rating={productData?.rating}
            reviewCount={productData?.reviews_count}
            image={productData?.product_img}
            tags={productData?.tags}
            document_as_product={productData?.document_as_product}
            onAddToCart={handleAddToCart}
            onBuyNow={handleBuyNow}
          />
          {/* <ProductInfo
            brand={productData?.brand}
            isShowPrice={isShowPrice}
            product_feature={productData?.product_feature}
            product_id={productData?.product_id}
            compatible_vehicles={productData?.compatible_vehicles}
            name={productData?.product_name}
            product_price={productData?.product_price}
            product_offer_price={productData?.product_offer_price}
            rating={productData?.rating}
            reviewCount={productData?.reviews_count}
            image={productData?.product_img}
            tags={productData?.tags}
            document_as_product={productData?.document_as_product}
            onAddToCart={handleAddToCart}
            onBuyNow={handleBuyNow}
          /> */}
        </div>
      </section>

      <section className={styles.section}>
        <ProductFeatures
          key_feature={productData?.key_feature || []}
          description={productData?.description || ""}
        />
      </section>

      <section className={styles.section}>
        <ProductSpecifications
          aspect_ratio={productData?.aspect_ratio}
          tyer_type={productData?.tyer_type}
          tyer_ps={productData?.tyer_ps}
          width={productData?.width}
          rim={productData?.rim}
        />
      </section>

      <section className={styles.section}>
        <SimilarProducts
          title="Similar Products"
          subtitle="You may also like"
          products={similarProducts}
        />
      </section>
    </div>
  );
};

export default ProductDetailPage;
